<template>
  <b-modal centered
           id="how-to-use-popup"
           ref="how-to-use-popup"
           v-bind:visible="showHowToUsePopup"
           size="lg"
           title="איך זה עובד"
           hide-header-close
           footer-class="bordered-footer"
           ok-title="סגור"
           ok-variant="secondary"
           body-class="scroll-modal"
           ok-only>
    <p class="how-to-use-text">הכלי לפענוח ראשי תיבות נועד לפתוח ראשי תיבות ולהציג את הטקסט המקורי לפני הקיצור.
      <br />הכלי מאתר ומפענח ראשי תיבות שמצויים בטקסטים מודרנים ובטקסטים רבניים.
    </p>
    <h2 class="how-to-use-header">אופן השימוש בכלי</h2>
    <p class="how-to-use-text">
      <ul style="list-style-type: disc">
        <li>הזינו טקסט בחלון המיועד לכך ולחצו על ״החל פיענוח״.</li>
        <li>במסך התוצאות, יוצגו ראשי התיבות שפוענחו בצבע כחול.</li>
        <li>כדי לעבור בטקסט עצמו בין ראשי התיבות המפוענחים היעזרו בחץ השמאלי ובחץ הימני של המקלדת, או בחרו טקסט עם העכבר.</li>
        <li>לכל ראשי תיבות שבהם קיים מספר אפשרויות פענוח, הן יופיעו בצד שמאל. כדי לעבור בין אפשרויות הפענוח השתמשו בחץ התחתון ובחץ העליון של המקלדת, או בחרו אפשרות עם העכבר.</li>
      </ul>
    </p>
    <h2 class="how-to-use-header">סרגל כלים</h2>
    <ul class="tools">
      <li>העתקה: קיצור מקלדת Shift+c
        <ul>
          <li>העתקה ללא ראשי תיבות מקוריים: לצד כפתור ההעתקה מופיע חץ. בלחיצה על החץ אפשר לסמן העתקה שאינה כוללת ראשי תיבות.
            <br/>
            במידה והפענוח יהיה זהה לראשי תיבות המקוריים, ראשי התיבות המקוריים לא יופיעו. לדוגמה: רש״י
          </li>
        </ul>
      </li>
      <li>הורדה: קיצור מקלדת Shift+d
        <ul>
          <li>אפשר לבחור אם לכלול ראשי תיבות מקוריים או לא.</li>
        </ul>
      </li>
      <li>הגדלה / הקטנה של הטקסט
        <ul>
          <li>הגדלה: קיצור מקלדת Ctrl++</li>
          <li>הקטנה: קיצור מקלדת Ctrl+-</li>
        </ul>
      </li>
      <li>שחזור פעולה / ביטול פעולה
        <ul>
          <li>שחזור פעולה: קיצור מקלדת Ctrl+y</li>
          <li>ביטול פעולה: קיצור מקלדת Ctrl+z</li>
        </ul>
      </li>
      <li>הצגה / הסתרה של ראשי תיבות מקוריים: קיצור מקלדת Shift+t
        <ul>
          <li>ראשי תיבות מקוריים יופיעו בטקסט בצבע אפור.</li>
        </ul>
      </li>
      <li>עריכת טקסט: קיצור מקלדת Ctrl+e 
        <ul>
          <li>כדי לערוך יותר ממילה אחת, בחרו עם העכבר את המילים שאתם רוצים לערוך ולחצו על ״ערוך טקסט״ או על Shift+E.</li>
          <li>הטקסט שמוצג בתיבה הוא הטקסט המקורי לפני פיענוח ראשי התיבות.</li>
        </ul>
      </li>
      <li>טעינת טקסט חדש: בטעינת טקסט חדש, תאבדו את הטקסט הקיים.</li>
      <li>השינויים נשמרו: חיווי על כך שהפרויקט נשמר בזיכרון הדפדפן. הדפדפן יבצע שמירה אוטומטית בכל חמש דקות.</li>
    </ul>
    <h2 class="how-to-use-header">אזור אישי</h2>
    <p class="how-to-use-text mt-3">
      <strong>מאגר אישי</strong>
    </p>
    <p class="how-to-use-text">מאגר אישי הוא אוסף של אפשרויות לפיענוח ראשי תיבות שהמשתמש יצר. אפשרויות פענוח מהמאגר האישי יופיעו בראש רשימת אפשרויות הפענוח.
      <br />השימוש במאגר האישי יתאפשר רק למשתמשים שמחוברים לחשבון האישי שלהם.
    </p>
    <ul class="dictionary-tree">
      <li>הוספת אפשרות פענוח למאגר: באמצעות אזור ״אפשרויות פיענוח״. לחיצה על הכוכב שמופיע במעבר עכבר על אפשרות הפיענוח, תוסיף את האפשרות למאגר ותמקם אותה תמיד בראש הרשימה.
      </li>
      <li>הסרת אפשרות פיענוח מהמאגר:
        <ul>
          <li>באמצעות "האזור האישי": לחיצה על ה-X שיופיע במעבר עכבר תסיר את האפשרות מהמאגר.</li>
          <li>באמצעות אזור "אפשרויות פיענוח": לחיצה על הכוכב שיופיע במעבר עכבר תסיר את האפשרות מהמאגר.
            <ul>
              <li>הסרת אפשרות שבמקור השתייכה למאגר של דיקטה, תחזיר אותה למאגר (אין אפשרות למחוק לצמיתות מרשימת "אפשרויות פענוח" את האפשרויות מהמאגר של דיקטה).</li>
            </ul>
          </li>
        </ul>
      </li>
      <li>דפדוף במאגר: בראש העמוד מופיע סרגל ניווט. לחיצה על אות תגלול את העמוד לאזור של האות.
      </li>
    </ul>
    <p class="how-to-use-text">
      <strong>פיענוח פגום</strong>
    </p>
    <p class="how-to-use-text">המשתמש יוכל לסמן אפשרויות מתוך המאגר של דיקטה כאפשרויות פגומות. בעת החלת אפשרויות הפענוח, הכלי יימנע מיישום האפשרויות שסומנו כפגומות.
    </p>
    <ul class="dictionary-tree">
      <li>כדי לסמן אפשרות כפגומה, יש להתחבר לאזור האישי.
      </li>
      <li>סימון האפשרות כפגומה ייעשה מתוך רשימת אפשרויות הפענוח. במעבר עכבר על האפשרות יופיע חץ כלפי מטה. לחיצה על החץ תעביר את המילה לתחתית הרשימה, והמילה תקבל צבע אפור בהיר. כדי לבטל סימון של מילה פגומה יש ללחוץ שוב על החץ שיופיע במעבר עכבר.
      </li>
      <li>קיצור מקלדת לסימון או ביטול אפשרות פגומה: Shift+x
      </li>
      <li>כדי להסיר אפשרות של פיענוח פגום מהרשימה, יש ללחוץ על ה-X שיופיע במעבר עכבר, מתוך האזור האישי.
      </li>
      <li>אם המשתמש סימן את כל אפשרויות הפיענוח כפגומות, הכלי לא יפענח את ראשי התיבות.
      </li>
    </ul>
    <p class="how-to-use-text">הכלי לפענוח ראשי תיבות הוא כלי חינמי מבית דיקטה.
    </p>
  </b-modal>
</template>

<script>
export default {
  name: 'HowToUsePopup',
  props: ['showHowToUsePopup'],
  watch: {
    showHowToUsePopup (newShowHowToUsePopup) {
      if (newShowHowToUsePopup) this.$refs['how-to-use-popup'].show()
    }
  }
}
</script>
<style scoped>
#how-to-use-popup p, #how-to-use-popup li {
  text-align: justify;
}
li {
  margin: 10px 0;
}
.tools li li {
  list-style-type: circle;
}
.dictionary-tree li {
  list-style-type: disc;
}
.dictionary-tree li li li {
  list-style-type: circle;
}
</style>
